module.exports = "/static/assets/45d490462c846e04081f2024ba2d8e15.png";